import { createElement } from "./create-element";
import { debounce } from "lodash";

/** Options
 * window.mainNavPreventSortingOutOfMoreMenu = true (default false);
 */

const desktopNavHolderEl = document.querySelector("#desktop-nav-holder");
const offCanvasNavEl = document.querySelector(".offcanvas-nav");
const initialMoreMenuEl = document.querySelector("li:has(> #navbarDropdown-mehr)");

const moreMenuSpace = 100;
const moreItemsSeparately = [];

const storedItems = [];
const storedItemsForOffcanvas = [];

const buildMoreMenuEl = (navItems) => {
  const liEl = createElement("li", {
    classes: ["nav-item", "dropdown"],
  });
  const menuEl = createElement("ul", {
    classes: ["dropdown-menu"],
    attributes: {
      "aria-labelledby": "navbarDropdown-mehr",
    },
  });
  const linkEl = createElement("a", {
    id: "navbarDropdown-mehr",
    classes: ["nav-link", "dropdown-toggle"],
    attributes: {
      href: "#",
      "data-bs-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
    },
  });

  linkEl.innerHTML = `
    Mehr
    <ui-icon icon="chevron-20"></ui-icon>
  `;

  if (navItems) {
    navItems.forEach((navItem) => {
      menuEl.appendChild(navItem);
    });
  }

  liEl.appendChild(linkEl);
  liEl.appendChild(menuEl);

  return liEl;
};

const processCloneForOffcanvas = (item) => {
  const clone = item.cloneNode(true);
  const link = clone.querySelector("a[id], [aria-labelledby]");

  if (link) {
    if (link.id) link.id += "-offcanvas";
    if (link.getAttribute("aria-labelledby")) {
      link.setAttribute("aria-labelledby", link.getAttribute("aria-labelledby") + "-offcanvas");
    }
  }

  const dropdownMenu = clone.querySelector(".dropdown-menu");
  if (dropdownMenu) {
    const collapseId = link.id + "-collapse";
    link.classList.remove("dropdown-toggle");
    link.setAttribute("data-bs-toggle", "collapse");
    link.classList.add("collapsed");
    link.href = `#${collapseId}`;
    link.setAttribute("aria-controls", collapseId);

    const collapseDiv = createElement("div", { id: collapseId, classes: ["collapse"] });

    storedItems.forEach((item) => {
      const link = item.querySelector("a.nav-link.dropdown-toggle");
      const menu = item.querySelector("ul.dropdown-menu");
      if (link && menu) {
        menu.setAttribute("aria-labelledby", link.id);
      }
    });

    dropdownMenu.classList.remove("dropdown-menu"); // Remove the leftover class
    dropdownMenu.classList.add("collapse-menu");
    collapseDiv.appendChild(dropdownMenu);

    clone.appendChild(collapseDiv);
  }

  return clone;
};

try {
  if (desktopNavHolderEl) {
    const desktopNavHolderUlEl = desktopNavHolderEl.querySelector(":scope > ul");

    const redoNav = () => {
      desktopNavHolderUlEl.innerHTML = "";
      const navHolderWidth = desktopNavHolderEl.getBoundingClientRect().width;
      const remainingItems = [...storedItems];

      for (const item of storedItems) {
        desktopNavHolderUlEl.appendChild(item);
        const navHolderUlWidth = desktopNavHolderUlEl.getBoundingClientRect().width;
        const remainingWidth = navHolderWidth - navHolderUlWidth - moreMenuSpace;

        if (remainingWidth < 0) {
          desktopNavHolderUlEl.removeChild(item);
          break;
        }

        remainingItems.shift();
      }

      if (window.mainNavPreventSortingOutOfMoreMenu) {
        remainingItems.push(...moreItemsSeparately);
      }

      if (remainingItems.length > 0) {
        const moreMenuEl = buildMoreMenuEl(remainingItems);
        desktopNavHolderUlEl.appendChild(moreMenuEl);
      }
    };

    if (desktopNavHolderUlEl) {
      if (initialMoreMenuEl) {
        // append initialMoreMenuEl to last pos within its parent
        initialMoreMenuEl.parentNode.appendChild(initialMoreMenuEl);
      }
      let mainNavItemEls = desktopNavHolderUlEl.querySelectorAll(":scope > li");
      mainNavItemEls.forEach((mainNavItemEl) => {
        storedItemsForOffcanvas.push(mainNavItemEl.cloneNode(true));
      });

      if (initialMoreMenuEl) {
        const initialMoreMenuItemEls = initialMoreMenuEl.querySelectorAll(":scope > ul > li");
        initialMoreMenuItemEls.forEach((menuItemEl) => {
          if (window.mainNavPreventSortingOutOfMoreMenu) {
            moreItemsSeparately.push(menuItemEl);
          } else {
            desktopNavHolderUlEl.appendChild(menuItemEl);
          }
        });
        initialMoreMenuEl.remove();
      }

      mainNavItemEls = desktopNavHolderUlEl.querySelectorAll(":scope > li");
      mainNavItemEls.forEach((mainNavItemEl) => {
        storedItems.push(mainNavItemEl);
      });

      // Set aria-labelledby for each dropdown menu to match the ID of the corresponding link
      storedItems.forEach((item) => {
        const link = item.querySelector("a.nav-link.dropdown-toggle");
        const menu = item.querySelector("ul.dropdown-menu");
        if (link && menu) {
          menu.setAttribute("aria-labelledby", link.id);
        }
      });

      redoNav();

      window.addEventListener("resize", debounce(redoNav, 100));

      const duplicatedItems = storedItemsForOffcanvas.map(processCloneForOffcanvas);

      duplicatedItems.forEach((item) => {
        offCanvasNavEl.appendChild(item);
      });
    }
  }
} catch (error) {
  console.error(error);
}
